module.exports = __webpack_public_path__ + "c_static/img/1-7搜索截图.fe72b89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/1-7搜索截图.jpg
// module id = tv4N
// module chunks = 33